var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"boarding-card"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"check-tab"},[_c('CheckInTab',{attrs:{"tabInit":_vm.tabInit}})],1),_c(_vm.stepName,{tag:"components",attrs:{"stepData":_vm.stepData},on:{"callback":_vm.nextStep}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }